export const OPPORTUNITY_CHART_LOADING = 'OPPORTUNITY_CHART_LOADING'
export const GET_OPPORTUNITY_CHART_DATA = 'GET_OPPORTUNITY_CHART_DATA'
export const GET_OPPORTUNITY_CHART_PROSPECT_STAGE = 'GET_OPPORTUNITY_CHART_PROSPECT_STAGE'
export const GET_OPPORTUNITY_CHART_OPPORTUNITIES = 'GET_OPPORTUNITY_CHART_OPPORTUNITIES'
export const GET_OPPORTUNITY_CHART_PROSPECTS = 'GET_OPPORTUNITY_CHART_PROSPECTS'
